import { h } from "preact";
import { observer } from "mobx-react";
import { t, translate } from "restaumatic-client";
import EditBlock from "./EditBlock";
function FulfillmentTimeBlock(props) {
    const { editBtnRef, fulfillmentTime, isRequired, onEdit } = props;
    const { isEditable, formattedValue, isTouched, hasValue } = fulfillmentTime;
    const label = translate(t.activerecord.attributes.order.deliver_at);
    const hasError = isRequired && isTouched && !hasValue;
    const actionText = hasValue
        ? translate(t.actions.change)
        : translate(t.orders.form.choose_date);
    return (h("div", { class: "form-group" },
        h(EditBlock, { actionBtnRef: editBtnRef, ariaLabel: label, prefixType: "icon", prefixIcon: "time", title: formattedValue.title, description: formattedValue.description, actionTrigger: "block", actionLabel: actionText, onClick: onEdit, isDisabled: !isEditable, hasError: hasError, dataFieldId: "fulfillmentTime.edit" })));
}
export default observer(FulfillmentTimeBlock);
